// src/utils/api.js
import axios from "axios";
import store from "@/store";

const API_ROOT = process.env.VUE_APP_API_ROOT;

// GET
export async function apiGet(url, params = {}, config = {}) {
  const access = store.getters.access;

  return axios.get(`${API_ROOT}${url}`, {
    params,
    headers: {
      Authorization: `Bearer ${access}`,
    },
    ...config,
  });
}

// POST
export async function apiPost(url, data = {}, config = {}) {
  const access = store.getters.access;

  return axios.post(`${API_ROOT}${url}`, data, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
    ...config,
  });
}

// PUT
export async function apiPut(url, data = {}) {
  const access = store.getters.access;

  return axios.put(`${API_ROOT}${url}`, data, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  });
}

// PATCH
export async function apiPatch(url, data = {}) {
  const access = store.getters.access;

  return axios.patch(`${API_ROOT}${url}`, data, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  });
}

// POST straight to S3 via a presigned POST policy -- no Authorization header
// (the policy itself is the credential) and no API_ROOT prefix (it's already
// an absolute S3 URL). `fields` is the dict of policy fields the presign
// endpoint returned (key, Content-Type, policy, signature, etc.) -- S3
// requires every field to be present in the multipart body, with the actual
// file field appended LAST.
const storageUploadClient = axios.create();

export async function uploadToPresignedUrl(url, blob, fields, contentType) {
  const formData = new FormData();
  Object.entries(fields || {}).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append("file", blob, `upload.${contentType.split("/")[1] || "jpg"}`);

  return storageUploadClient.post(url, formData, {
    timeout: 15000,
    withCredentials: false,
  });
}

// DELETE
export async function apiDelete(url) {
  const access = store.getters.access;

  return axios.delete(`${API_ROOT}${url}`, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  });
}
